import React from 'react';
import Header from './Header.js';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Box from '@material-ui/core/Box';

import BuildIcon from '@material-ui/icons/Build';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
      padding: 20,
      paddingTop:100,
  },
  card: {
    //padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
      //margin: theme.spacing(2),
      alignItems: 'center',
  }, 
}));

export default function UnderConstructionScreen (props) {
    const classes = useStyles();
    return <>
            <div className={classes.root}>
                <Header title={<><BuildIcon size="large"/> Under Construction</>} subTitle="This section is currently not available." />
                <Grid container spacing={3}>
                    <Grid item xs={9}>
                        <Box>
                          <br /><br />
                            <Typography variant="h6" color="inherit">Please check back later as we add more functionality.</Typography>
                            
                        </Box>
                    </Grid>
                </Grid>
            </div>
        </>
}